import formatTableJson from '@/config/tableComponentParams.js'
import { deviceStatus, onOffLineStatus } from '@/config/status'
import i18n from '@/locales/index'
export default formatTableJson([
  // {
  //   filed: 'name',
  //   label: '设备名称',
  //   width: '200px'
  // },
  {
    filed: 'code',
    label: i18n.t('Device.deviceCode'),
    width: '180px'
  },
  {
    filed: 'mac',
    label: i18n.t('Device.MAC'),
    width: '180px'
  },
  // {
  //   filed: 'productName',
  //   label: '所属产品',
  //   width: '180px'
  // },
  // {
  //   filed: 'state',
  //   label: '设备状态',
  //   type: 'status',
  //   statusProps: deviceStatus,
  //   formatFn: function(_, row) {
  //     return row.stateName
  //   }
  // },
  // {
  //   filed: 'online',
  //   label: '在离线',
  //   type: 'status',
  //   statusProps: onOffLineStatus,
  //   formatFn: function(_, row) {
  //     return row.onlineName
  //   }
  // },
  {
    filed: 'factoryArea',
    label: i18n.t('Device.factoryArea'),
    width: '250px'
  },
  {
    filed: 'createTime',
    label: i18n.t('Common.createTime'),
    type: 'time',
    // sortable: true,
    width: '180px',
    showOverflowTooltip: true
  }
])
